// extracted by mini-css-extract-plugin
export default {"cardsGroup":"CardsGroup_cardsGroup__TVj2P","title":"CardsGroup_title__kJMVD","list":"CardsGroup_list__DR22H"};